export class Payments {
    id:string;
    userId:string;
    dealerId:string;
    userName: string;
    paymentAmount:number;
    comments:string;
    paymentDate:string;
    dealerBalanceAfter:number;
    dealerName?:string;
    paymentType?:string = "Manual";
    public constructor(init?: Partial<Payments>) {
        Object.assign(this, init);
}
}